import { render, staticRenderFns } from "./AssignedAssistantCard.vue?vue&type=template&id=64fe7874&scoped=true&"
import script from "./AssignedAssistantCard.vue?vue&type=script&lang=ts&"
export * from "./AssignedAssistantCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedAssistantCard.vue?vue&type=style&index=0&id=64fe7874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe7874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
